import { IFetchSODConflictsBody } from "../../../../common/SODUtils/SODconstants";

export const actionTypes = {
  ADMIN_BR_OU_REQUEST: "ADMIN_BR_OU_REQUEST",
  ADMIN_BR_OU_REQUEST_SUCCESS: "ADMIN_BR_OU_REQUEST_SUCCESS",
  ADMIN_BR_OU_REQUEST_FAILURE: "ADMIN_BR_OU_REQUEST_FAILURE",

  ADMIN_BR_BR_REQUEST: "ADMIN_BR_BR_REQUEST",
  ADMIN_BR_BR_REQUEST_SUCCESS: "ADMIN_BR_BR_REQUEST_SUCCESS",
  ADMIN_BR_BR_REQUEST_FAILURE: "ADMIN_BR_BR_REQUEST_FAILURE",

  ADMIN_BR_ENTITLEMENT_REQUEST: "ADMIN_BR_ENTITLEMENT_REQUEST",
  ADMIN_BR_ENTITLEMENT_REQUEST_SUCCESS: "ADMIN_BR_ENTITLEMENT_REQUEST_SUCCESS",
  ADMIN_BR_ENTITLEMENT_REQUEST_FAILURE: "ADMIN_BR_ENTITLEMENT_REQUEST_FAILURE",

  ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST: "ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST",
  ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST_SUCCESS:
    "ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST_SUCCESS",
  ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST_FAILURE:
    "ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST_FAILURE",

  ADMIN_BR_DELETE_BR_REQUEST: "ADMIN_BR_DELETE_BR_REQUEST",
  ADMIN_BR_DELETE_BR_REQUEST_SUCCESS: "ADMIN_BR_DELETE_BR_REQUEST_SUCCESS",
  ADMIN_BR_DELETE_BR_REQUEST_FAILURE: "ADMIN_BR_DELETE_BR_REQUEST_FAILURE",

  ADMIN_BR_SELECT_OU: "ADMIN_BR_SELECT_OU",
  ADMIN_BR_SELECT_BR: "ADMIN_BR_SELECT_BR",
  ADMIN_BR_RESET_BR: "ADMIN_BR_RESET_BR",
  ADMIN_BR_UPDATE_TARGET_BR: "ADMIN_BR_UPDATE_TARGET_BR",

  ADMIN_BR_SET_ENTITLEMENTS_TARGET_BR: "ADMIN_BR_SET_ENTITLEMENTS_TARGET_BR",

  ADMIN_BR_SET_CHAIN_ENTITLEMENTS_BR: "ADMIN_BR_SET_CHAIN_ENTITLEMENTS_BR",

  SOD_CONFLICTS_ADMIN_BR: "SOD_CONFLICTS_ADMIN_BR",
  SOD_CONFLICTS_ADMIN_BR_SUCCESS: "SOD_CONFLICTS_ADMIN_BR_SUCCESS",
  SOD_CONFLICTS_ADMIN_BR_FAILURE: "SOD_CONFLICTS_ADMIN_BR_FAILURE",
  RESET_SOD_CONFLICTS_ADMIN_BR: "RESET_SOD_CONFLICTS_ADMIN_BR",

  ADMIN_BR_MGMT_CREATE_REQUEST: "ADMIN_BR_MGMT_CREATE_REQUEST",
  ADMIN_BR_MGMT_CREATE_REQUEST_SUCCESS: "ADMIN_BR_MGMT_CREATE_REQUEST_SUCCESS",
  ADMIN_BR_MGMT_CREATE_REQUEST_FAILURE: "ADMIN_BR_MGMT_CREATE_REQUEST_FAILURE",
  ADMIN_BR_MGMT_MODIFY_REQUEST: "ADMIN_BR_MGMT_MODIFY_REQUEST",
  ADMIN_BR_MGMT_MODIFY_REQUEST_SUCCESS: "ADMIN_BR_MGMT_MODIFY_REQUEST_SUCCESS",
  ADMIN_BR_MGMT_MODIFY_REQUEST_FAILURE: "ADMIN_BR_MGMT_MODIFY_REQUEST_FAILURE",
};

export const getPaginatedOuRequest = (payload: any) => ({
  type: actionTypes.ADMIN_BR_OU_REQUEST,
  payload,
});

export const getPaginatedOuRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_BR_OU_REQUEST_SUCCESS,
  payload,
});

export const getPaginatedOuRequestFailure = (error: any) => ({
  type: actionTypes.ADMIN_BR_OU_REQUEST_FAILURE,
  error,
});

export const selectOu = (payload: any) => ({
  type: actionTypes.ADMIN_BR_SELECT_OU,
  payload,
});

export const getBRRequest = (payload: any) => ({
  type: actionTypes.ADMIN_BR_BR_REQUEST,
  payload,
});

export const getBRRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_BR_BR_REQUEST_SUCCESS,
  payload,
});

export const getBRRequestFailure = (error: any) => ({
  type: actionTypes.ADMIN_BR_BR_REQUEST_FAILURE,
  error,
});

export const selectBr = (payload: any) => ({
  type: actionTypes.ADMIN_BR_SELECT_BR,
  payload,
});

export const updateBr = (payload: any) => ({
  type: actionTypes.ADMIN_BR_UPDATE_TARGET_BR,
  payload,
});

export const setEntitlementsTargetBR = (payload: any) => ({
  type: actionTypes.ADMIN_BR_SET_ENTITLEMENTS_TARGET_BR,
  payload,
});

export const setChainEntitlementsBR = (payload: any) => ({
  type: actionTypes.ADMIN_BR_SET_CHAIN_ENTITLEMENTS_BR,
  payload,
});

export const adminSodConflictsActionBR = (payload: IFetchSODConflictsBody) => ({
  type: actionTypes.SOD_CONFLICTS_ADMIN_BR,
  payload,
});

export const adminSodConflictsActionBRSuccess = (payload: any[]) => ({
  type: actionTypes.SOD_CONFLICTS_ADMIN_BR_SUCCESS,
  payload,
});

export const adminSodConflictsActionBRFailure = (err: Error) => ({
  type: actionTypes.SOD_CONFLICTS_ADMIN_BR_FAILURE,
  err,
});

export const adminResetSodConflictsActionBR = () => ({
  type: actionTypes.RESET_SOD_CONFLICTS_ADMIN_BR,
});

export const resetBr = () => ({
  type: actionTypes.ADMIN_BR_RESET_BR,
});

export const deleteBrRequest = (payload: any) => ({
  type: actionTypes.ADMIN_BR_DELETE_BR_REQUEST,
  payload,
});

export const deleteBRRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_BR_DELETE_BR_REQUEST_SUCCESS,
  payload,
});

export const deleteBrRequestFailure = (error: any) => ({
  type: actionTypes.ADMIN_BR_DELETE_BR_REQUEST_FAILURE,
  error,
});

export const getEntitlementRequest = (payload: any) => ({
  type: actionTypes.ADMIN_BR_ENTITLEMENT_REQUEST,
  payload,
});

export const getEntitlementRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_BR_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});

export const getEntitlementRequestFailure = (error: any) => ({
  type: actionTypes.ADMIN_BR_ENTITLEMENT_REQUEST_FAILURE,
  error,
});

export const getBrEntitlementRequest = (payload: any) => ({
  type: actionTypes.ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST,
  payload,
});

export const getBrEntitlementRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST_SUCCESS,
  payload,
});

export const getBrEntitlementRequestFailure = (error: any) => ({
  type: actionTypes.ADMIN_BR_GET_BE_ENTITLEMENTS_REQUEST_FAILURE,
  error,
});

export const createAdminBRRequestAction = (payload: FormData) => ({
  type: actionTypes.ADMIN_BR_MGMT_CREATE_REQUEST,
  payload,
});

export const createAdminBRRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_BR_MGMT_CREATE_REQUEST_SUCCESS,
  payload,
});

export const createAdminBRRequestFailure = (err: Error) => ({
  type: actionTypes.ADMIN_BR_MGMT_CREATE_REQUEST_FAILURE,
  err,
});

export const modifyAdminBRRequestAction = (payload: FormData) => ({
  type: actionTypes.ADMIN_BR_MGMT_MODIFY_REQUEST,
  payload,
});

export const modifyAdminBRRequestSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_BR_MGMT_MODIFY_REQUEST_SUCCESS,
  payload,
});

export const modifyAdminBRRequestFailure = (err: Error) => ({
  type: actionTypes.ADMIN_BR_MGMT_MODIFY_REQUEST_FAILURE,
  err,
});
